// En Home.js
import React from 'react';

function AccountManagement() {
  return <div>Account Management</div>;
}

export default AccountManagement;
